export const ageLimits = {
	investorAge: {
		min: 18,
		max: 99
	},
	entityAccountType: {
		max: 149
	}
};
